import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { User } from '../../interfaces/common/users';
import { AuthState } from './auth.states';
import { authFeatureKey } from './auth.reducer';

const getLoggedIn = (state: AuthState): boolean => state.loggedIn;
const getUser = (state: AuthState): User => state.user;

export const selectAuthState: MemoizedSelector<object, AuthState> = createFeatureSelector<AuthState>(authFeatureKey);
export const selectAuthUser: MemoizedSelector<object, User> = createSelector(selectAuthState, getUser);
export const isLoggedIn: MemoizedSelector<object, boolean> = createSelector(selectAuthState, getLoggedIn);
